module.exports = __WEBPACK_EXTERNAL_MODULE__babylonjs_loaders_glTF_index__;